import { type FunctionComponent, Suspense } from "react";

import type { Edition } from "shared/lib/edition";
import { useEditionValue } from "shared/lib/edition";

import { HeaderOnelineMenuItems } from "./header-oneline-menu-items";

type Props = { initEdition?: Edition };
export const HeaderOnelineMenu: FunctionComponent<Props> = ({ initEdition }) => {
  const edition = useEditionValue({ initializeWithValue: true });
  const finalEdition = initEdition ?? edition;

  // initEdition is resolved on the server and the home page query preloads the app
  // config, so render through a plain Suspense boundary to include the menu in the
  // first paint instead of waiting for mount.
  return (
    <Suspense fallback={null}>
      <HeaderOnelineMenuItems edition={finalEdition} />
    </Suspense>
  );
};

HeaderOnelineMenu.displayName = "HeaderOnelineMenu";
